import {css} from '../../theme/css'
import {theme} from '../../theme/theme'

export const classes = {
  // !important оверрайдит стили материала, надо чтобы модалки gwc перекрывали шапку
  root: css`
    outline: 1px solid ${theme.palette.grey[300]};
    z-index: 900 !important;
  `,
}
